import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { FlowTooltip } from '../Tooltips/FlowTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { FlowThumbnail } from './FlowThumbnail';
import { Thumbnail } from './Thumbnail';

export class FlowCard extends ContentCard {

  public render() {
    return (
      <div className={CardViewStyles.Card}>
        { FeatureFlags.flowThumbnailsEnabled ? (
            <TooltipAnchor tooltipContent={this.renderTooltipContent} width={DetailsTooltipStyles.Width} onShowTooltip={this.handleShowTooltip} delay={0}
              title={Messages.flowTooltipTitle()} disableAutoFocus={this.props.content.owner && this.props.content.owner.isHiddenInternalUser}>
              <Thumbnail
                defaultImageUrl={imgPath('spaces_masthead_flow.svg')}
                thumbnailImageUrl={this.props.content.thumbnailUrl}
                hoveredOrSelected={this.props.hoveredOrSelected}
                navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
                useBase64EncodedImage={true}
              />
            </TooltipAnchor>
          ) : (
            <FlowThumbnail
              hoveredOrSelected={this.props.hoveredOrSelected}
              navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
              owner={this.props.content.owner}
              urls={this.props.urls}
            />
          )
        }
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          <span>
            <FavoriteToggle
              canHaveKeyboardFocus={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite(this.props.content.id, 'flow')}
              onRemoveFavorite={() => this.props.removeContentFavorite(this.props.content.id, this.props.content.id, 'flow', this.props.content.name)}
            />
          </span>
          { this.renderActionsMenu() }
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <FlowTooltip
        content={this.props.content}
        urls={this.props.urls}
      />
    );
  }
}
